import React from 'react'
import NotFoundMessage from '../components/layout/NotFoundMessage'

export default function NotFoundPages() {
  return (
    <section>
      <NotFoundMessage />
    </section>
  )
}
